import { PropsWithChildren } from 'react'
import { Flex, RatingGroup, Text } from '@chakra-ui/react'

export const TestimonialTitle = ({
  title,
  style,
  subtitle,
}: PropsWithChildren<{ style?: React.CSSProperties; subtitle?: string; title: string }>): JSX.Element => {
  return (
    <Flex direction="column" alignItems="center" gap={2} style={style}>
      <Text as="h2" textAlign="left" lineHeight={1} fontSize={{ base: 'lg', md: '2xl' }} fontWeight="semibold">
        {title}
      </Text>
      <Text color="gray.a500" textAlign="center">
        {subtitle}
      </Text>
      <RatingGroup.Root count={5} value={4.5} size="md" colorPalette="orange" readOnly>
        <RatingGroup.HiddenInput />
        <RatingGroup.Control />
      </RatingGroup.Root>
    </Flex>
  )
}
